<template>
  <div class="antialiased">
    <Sidebar />
    <div class="page">
      <Header @keyup="_search" hint="Cari Driver" />
      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Planed Drivers</h2>
              </div>
            </div>
          </div>
          <div>
            <b-nav tabs>
              <b-nav-item>
                <router-link to="../distribution-plan/service-level">
                  Daftar Service Level
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link to="../distribution-plan">
                  Daftar Invoice Pending
                </router-link>
              </b-nav-item>
              <b-nav-item>
                <router-link to="../distribution-plan/jadwal">
                  Daftar Jadwal Pengiriman
                </router-link>
              </b-nav-item>
              <b-nav-item active>
                <router-link to="distribution-plan/planed-driver">
                  Daftar Planed Drivers
                </router-link>
              </b-nav-item>
            </b-nav>
          </div>
          <div style="margin-top: 20px">
            <div class="card">
              <Skeleton
                type="table"
                :length="14"
                class="mt-4 bg-white"
                v-if="loading"
              />
              <div class="table-responsive" v-if="drivers.length > 0">
                <table
                  class="table table-vcenter table-hover card-table table-striped"
                >
                  <thead>
                    <tr class="text-muted">
                      <th>Dikirim Oleh</th>
                      <th>Total Invoice</th>
                      <th>Total Value</th>
                      <th>Total In CTN</th>
                      <th></th>
                    </tr>
                  </thead>
                  <template v-for="(driver, index) in drivers"
                    ><tr
                      :style="{
                        backgroundColor:
                          activeDetail === driver.user_id ? '#d1d7e3' : '',
                      }"
                      :class="
                        activeDetail !== driver.user_id && activeDetail !== ''
                          ? 'bg-gray-lt'
                          : ''
                      "
                      v-if="
                        keyword === '' ||
                        driver.name
                          .toLowerCase()
                          .includes(keyword.toLowerCase())
                      "
                    >
                      <td>
                        {{ driver.name }}
                      </td>
                      <td>
                        {{
                          meta[driver.user_id]
                            ? meta[driver.user_id].total_invoice
                            : 0 || 0
                        }}
                      </td>
                      <td>
                        {{
                          ribuan(
                            (meta[driver.user_id]
                              ? meta[driver.user_id].sum_subtotal
                              : 0 || 0
                            ).toFixed(0)
                          )
                        }}
                      </td>
                      <td>
                        {{
                          ribuan(
                            (meta[driver.user_id]
                              ? meta[driver.user_id].sum_qty
                              : 0 || 0
                            ).toFixed(0)
                          )
                        }}
                      </td>
                      <td style="padding: 0; text-align: right">
                        <button
                          v-if="meta[driver.user_id]"
                          class="btn border-0 shadow-none"
                          @click="
                            activeDetail === driver.user_id
                              ? (activeDetail = '')
                              : (activeDetail = driver.user_id)
                          "
                        >
                          Show Details
                          <i
                            v-if="activeDetail !== driver.user_id"
                            class="fe fe-chevron-down ml-2"
                          ></i>
                          <i v-else class="fe fe-chevron-up ml-2"></i>
                        </button>
                      </td>
                    </tr>
                    <tr
                      v-if="activeDetail === driver.user_id"
                      :style="{
                        backgroundColor: '#e8effa',
                      }"
                    >
                      <td colspan="5" style="padding: 0">
                        <table
                          class="table table-vcenter table-hover card-table table-striped"
                        >
                          <thead>
                            <tr class="text-muted">
                              <th>No</th>
                              <th>No. Invoice</th>
                              <th style="width: 27%">Toko</th>
                              <th style="width: 5%">Tim</th>
                              <th>Status</th>
                              <th>SubTotal</th>
                              <th>Total CTN</th>
                              <th>Tgl PO</th>
                              <th>Tgl Jadwal</th>
                              <th>ETA</th>
                              <th>Print</th>
                            </tr>
                          </thead>
                          <tbody>
                            <template
                              v-for="(row, index) in reportDriver[driver.user_id]"
                            >
                              <tr
                                style="
                                  background-color: #d1d7e3;
                                  font-weight: bold;
                                "
                              >
                                <td colspan="3">Pengiriman : {{ row.tanggal }}</td>
                                <td class="" colspan="2"> {{ row.total_invoice }}</td>
                                <td class="" colspan="2"> {{ribuan((row.total_subtotal).toFixed(0))}}</td>
                                <td class="" colspan="4"> {{ row.total_qty }}</td>
                              </tr>
                              <tr
                                v-for="(penjualan, index) in row.details"
                                :key="penjualan.no_invoice"
                              >
                                <td>{{ index + 1 }}</td>
                                <td class="click-able text-primary">
                                  <div>{{ penjualan.no_invoice }}</div>
                                  <hr style="margin: 2px" />
                                  <div class="text-muted">
                                    PO:{{ penjualan.no_po }}
                                  </div>
                                </td>
                                <td>
                                  <div>
                                    [{{ penjualan.no_acc }}]
                                    {{ penjualan.nama_toko }}
                                  </div>
                                  <hr style="margin: 2px" />
                                  <div
                                    class="text-muted"
                                    style="text-transform: uppercase"
                                  >
                                    {{ penjualan.alamat }}
                                  </div>
                                </td>
                                <td>{{ penjualan.nama_tim }}</td>
                                <td>{{ penjualan.tipe_pembayaran }}</td>
                                <td>
                                  {{ ribuan(penjualan.subtotal + "||,0") }}
                                </td>
                                <td>
                                  {{ ribuan(penjualan.qty + "||,2") }}
                                </td>
                                <td>{{ penjualan.tanggal }}</td>
                                <td>{{ penjualan.tanggal_jadwal }}</td>
                                <td
                                  :class="
                                    _getClassForDate(
                                      penjualan.tanggal_jadwal,
                                      penjualan.eta
                                    )
                                  "
                                >
                                  {{ penjualan.eta }}
                                </td>
                                <td>
                                  {{ penjualan.print_count }}
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import moment from "moment";

export default {
  name: "DistributionPlanPlanedDriver",
  data() {
    return {
      drivers: [],
      loading: true,
      data: null,
      meta: null,
      activeDetail: "",
      keyword: "",
    };
  },
  mixins: [helper],
  computed: {
    reportDriver(){
      var report = {}
      for(const driverId in this.data){
        const reportByDriver = this.data[driverId]
        report[driverId] = [];
        for(const date in reportByDriver){
          const reprot_by_date = reportByDriver[date]
          const total_invoice = reprot_by_date.length
          var total_qty = 0
          var total_subtotal = 0
          if(total_invoice > 0) {
            total_qty = reprot_by_date.reduce((sum, item) => sum + parseFloat(item.qty), 0);
            total_subtotal = reprot_by_date.reduce((sum, item) => sum + item.subtotal, 0);
          }

          const result = {
            tanggal: date,
            total_invoice: total_invoice,
            total_qty: Math.round(total_qty),
            total_subtotal: Math.round(total_subtotal),
            details: reprot_by_date,
          }
          report[driverId].push(result)
        } 
      }
      return report;
    }
  },
  methods: {
    _getClassForDate(tanggal_jadwal, eta) {
      return moment(tanggal_jadwal).isAfter(moment(eta)) ? "text-red" : "";
    },
    _search(keyword) {
      this.activeDetail = "";
      this.keyword = keyword;
    },
    _fetchData() {
      this.axios
        .get("distribusi_report/planed_drivers")
        .then((res) => {
          this.data = res.data.data;
          this.meta = res.data.meta;
          this.loading = false;
        })
        .catch((err) => {
          this.onError(err);
        });
    },
    _fetchDrivers() {
      this.axios
        .get("driver/list/simple")
        .then((res) => {
          this.drivers = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.onError(err);
        });
    },
  },
  watch: {},
  mounted() {
    this._fetchDrivers();
    this._fetchData();
  },
};
</script>
<style scoped>
.strong {
  font-weight: bold;
}

.btn-position {
  position: fixed;
  right: 15px;
  bottom: 15px;
}

.navbar-text {
  padding-top: 0.5rem !important;
}

.nav-item {
  width: 20%;
}
</style>
